<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="parametersG20Kzgs">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="工号">
            <el-input v-model.trim="filter.creator" clearable/>
          </vm-search>
          <vm-search label="PC号">
            <el-input v-model.trim="filter.contractCode" clearable/>
          </vm-search>
          <vm-search label="创建时间">
            <div class="block">
              <el-date-picker
                  v-model="filter.startTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  style="width: 165px"
                  placeholder="选择开始时间"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.endTime"
                  value-format="yyyy-MM-dd 23:59:59"
                  type="date"
                  style="width: 165px"
                  placeholder="选择结束时间"/>
            </div>
          </vm-search>
          <vm-search label="柜体条码">
            <el-input v-model.trim="filter.barCode" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column
          fixed
          width="100"
          prop="creator"
          align="center"
          label="工号"/>
      <el-table-column
          fixed
          width="100"
          prop="contractCode"
          align="center"
          label="PC号"/>
      <el-table-column fixed prop="magneticPole" align="center" label="磁极角"/>
      <el-table-column
          fixed
          width="90"
          prop="checkTime"
          align="center"
          label="检验时间"/>
      <el-table-column prop="inspectionBenchNo" width="120" align="center" label="检验台编号"/>
      <el-table-column prop="controlMode" align="center" label="控制方式"/>
      <el-table-column prop="productModel" align="center" label="产品型号"/>
      <el-table-column prop="serviceFloor" align="center" label="服务楼层"/>
      <el-table-column prop="specificationTableNo" align="center" label="规格表号"/>
      <el-table-column prop="hoistingHeight" align="center" label="提升高度"/>
      <el-table-column prop="baseStation" align="center" label="基站"/>
      <el-table-column prop="controlBoardNo" width="120" align="center" label="一体化控制板型号"/>
      <el-table-column prop="transducerModel" width="100" align="center" label="变频器型号"/>
      <el-table-column prop="driveProgram" align="center" label="驱动程序"/>
      <el-table-column prop="logicProgramVersion" width="120" align="center" label="逻辑程序版本"/>
      <el-table-column prop="specificationTableVersion" width="100" align="center" label="规格表版本"/>
      <el-table-column prop="parameterReading" align="center" width="130" label="出厂参数规格表读取"/>
      <el-table-column prop="sealStarLoop" align="center" label="封星回路"/>
      <el-table-column prop="softwareVersionComparison" width="100" align="center" label="软件版本比对"/>
      <el-table-column prop="driverVersionComparison" width="100" align="center" label="驱动版本比对"/>
      <el-table-column prop="debugParameterWrite" width="100" align="center" label="调试参数写入"/>
      <el-table-column prop="mainBoardIOComparison" width="100" align="center" label="主板IO比对"/>
      <el-table-column prop="safetyCircuit" align="center" label="安全回路"/>
      <el-table-column prop="doorLock" align="center" label="门锁"/>
      <el-table-column prop="angleLearn" width="100" align="center" label="角度自学习"/>
      <el-table-column prop="emergencyStopTest" align="center" label="急停测试"/>
      <el-table-column prop="emergencyElectricTest" width="100" align="center" label="紧急电动测试"/>
      <el-table-column prop="portalCraneVoltage" align="center" label="门机电压"/>
      <el-table-column prop="carIlluminationVoltage" width="100" align="center" label="轿厢照明电压"/>
      <el-table-column prop="brakeVoltage" align="center" label="抱闸电压"/>
      <el-table-column prop="interPhoneVoltage" width="90" align="center" label="对讲机电压"/>
      <el-table-column prop="wellLearn" align="center" width="90" label="井道自学习"/>
      <el-table-column prop="callLadderTest" align="center" label="呼梯测试"/>
      <el-table-column prop="flatBedFunction" align="center" width="100" label="微动平层功能"/>
      <el-table-column prop="doorSideTest" align="center" width="90" label="门旁路测试"/>
      <el-table-column prop="gateLoopConnect" align="center" width="90" label="门回路短接"/>
      <el-table-column prop="parameterSpecificationWrite" width="100" align="center" label="参数规格写入"/>
      <el-table-column prop="factoryParametersAffirm" width="100" align="center" label="出厂参数确认"/>
    </vm-table>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import KeyComponentEdit from "@/views/information/KeyComponent/KeyComponentEdit";
  export default {
    name: "",
    components: {VmTable,VmSearch},
    data() {
      return {
        idList: "",
        filter: {
          barCode: "",
          clientContractNo: "",
          startTime: "",
          endTime: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
    },
  };
</script>

<style scoped>

</style>
